import styled from 'styled-components';
import MuiTextField from '@mui/material/TextField';

export const TextField = styled(MuiTextField)`
  display: flex;
  width: 100%;

  &.fake-input {
    .MuiInputBase-root {
      .MuiInputBase-input {
        -webkit-text-fill-color: ${(props) => props.theme.input.color};
      }
    }
  }

  .MuiInputBase-root {
    background: ${(props) => props.theme.input.background};

    .MuiInputBase-input {
      height: auto;
      padding: 8.5px 14px;
    }

    .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${(props) => props.theme.input.border};
    }

    &:hover,
    &:focus {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.input.border};
        box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
      }
    }

    &.MuiInputBase-adornedStart {
      padding-left: 8px;

      .MuiInputBase-input {
        padding-left: 0;
      }
    }
  }

  &.Mui-focused {
    .MuiFormControl-root {
      .MuiInputBase-root {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${(props) => props.theme.input.border};
          box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
        }
      }
    }
  }
`;
